import { useParams, useNavigate, Link } from "react-router-dom";
import { BillPage as BillPageView } from "@/components/BillPage";
import { useModules } from "@/auth/ModulesContext";
import { useApAccountingSettings } from "@/hooks/useAccountingConnected";
import { BooksDocumentCard } from "@/books/BooksDocumentCard";

// No fallback: build.ts requires API_BASE_URL, and a dev default would point SignalR at another environment.
const HUB_BASE_URL = process.env.API_BASE_URL ?? "";

export function BillPage() {
  const { billId } = useParams<{ billId: string }>();
  const navigate = useNavigate();
  const { hasModule, holdsModule, modules } = useModules();
  // Resolved entitlement: payables-settings 403s without ap.accounting, raising the global "not in your plan" toast.
  const accounting = useApAccountingSettings(modules !== null && hasModule("ap.accounting"));

  if (!billId) return null;

  return (
    <BillPageView
      billId={billId}
      onBack={() => navigate("/bills")}
      onEditClick={(id) => navigate(`/bills/${id}/edit`)}
      onSupplierClick={(supplierId) => navigate(`/suppliers/${supplierId}`)}
      onPurchaseOrderClick={(poId) => navigate(`/purchase-orders/${poId}`)}
      onDeliveryNoteClick={(dnId) => navigate(`/delivery-notes/${dnId}`)}
      onMatchUiClick={(id) => navigate(`/bills/${id}/match`)}
      onCreditNoteClick={(id) => navigate(`/supplier-credit-notes/${id}`)}
      onBillClick={(id) => navigate(`/bills/${id}`)}
      hubBaseUrl={HUB_BASE_URL}
      accounting={accounting}
      booksCard={holdsModule("books") ? <BooksDocumentCard sourceType="Bill" sourceId={billId} /> : null}
      apSettingsLink={<Link to="/bills/approval-policies" className="underline">approval policies</Link>}
    />
  );
}
